import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const internalLinks = {
  'PRIVACY_POLICY.md': '/privacy',
  'TERMS_OF_SERVICE.md': '/terms',
};

export default function LegalPage({ doc }) {
  const [text, setText] = useState('');

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/legal/${doc}.md`)
      .then((res) => res.text())
      .then(setText)
      .catch(() => setText('Failed to load document.'));
  }, [doc]);

  return (
    <div className="legal-page">
      <div className="legal-page-content">
      <Link to="/">&larr; Back</Link>
      <ReactMarkdown
        components={{
          a: ({ href, children }) =>
            internalLinks[href] ? (
              <Link to={internalLinks[href]}>{children}</Link>
            ) : (
              <a href={href} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            ),
        }}
      >
        {text}
      </ReactMarkdown>
      </div>
    </div>
  );
}

export function LegalLinks() {
  return (
    <div className="legal-links">
      <Link to="/privacy">Privacy Policy</Link>
      <Link to="/terms">Terms of Service</Link>
    </div>
  );
}
